import React from 'react'
import Prism from 'prismjs';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import { ReactReduxContext } from 'react-redux'
import ClipboardJS from 'clipboard';

import { buildMjmlSource, renderEmailMjml } from "./mjmlString";

var beautify = require('js-beautify').html;

const gutterStyle = {
    padding: '1em 0.75em',
    textAlign: 'right',
    color: '#75715e',
    borderRight: '1px solid rgba(255,255,255,0.1)',
    userSelect: 'none',
    fontFamily: "Consolas, Monaco, 'Andale Mono', 'Ubuntu Mono', monospace",
    fontSize: '1em',
    lineHeight: '1.5',
    flexShrink: 0,
    minWidth: '2.5em',
    backgroundColor: '#272822',
};

const CodeBlock = ({ code, language, id }) => {
    const lines = code.split('\n');
    const highlighted = Prism.highlight(code, Prism.languages[language], language);
    return (
        <div style={{ display: 'flex', overflowX: 'auto', marginTop: 8 }}>
            <div style={gutterStyle}>
                {lines.map((_, i) => <div key={i}>{i + 1}</div>)}
            </div>
            <pre className={`language-${language}`} style={{ margin: 0, flex: 1, overflow: 'visible', borderRadius: 0 }}>
                <code
                    className={`language-${language}`}
                    id={id}
                    dangerouslySetInnerHTML={{ __html: highlighted }}
                />
            </pre>
        </div>
    );
};

const MjmlContent = ({ store }) => {
    const [compiledHtml, setCompiledHtml] = React.useState('');
    const mjmlSource = buildMjmlSource(store);

    React.useEffect(() => {
        new ClipboardJS('#copyMjmlSourceButton');
        new ClipboardJS('#copyMjmlHtmlButton');
    });

    React.useEffect(() => {
        renderEmailMjml(store).then(setCompiledHtml);
    }, [mjmlSource]);

    const beautifiedSource = beautify(mjmlSource, { indent_size: 2, space_in_empty_paren: true });
    const beautifiedHtml = beautify(compiledHtml, { indent_size: 2, space_in_empty_paren: true });

    return (
        <div>
            <Typography variant="h6">MJML Source</Typography>
            <Button variant="contained"
                data-clipboard-target="#mjmlSourceString" id="copyMjmlSourceButton" color="secondary">
                Copy to clipboard
            </Button>
            <CodeBlock code={beautifiedSource} language="markup" id="mjmlSourceString" />

            <Typography variant="h6" style={{ marginTop: 16 }}>Compiled HTML</Typography>
            <Button variant="contained"
                data-clipboard-target="#mjmlHtmlString" id="copyMjmlHtmlButton" color="secondary">
                Copy to clipboard
            </Button>
            <CodeBlock code={beautifiedHtml} language="html" id="mjmlHtmlString" />
        </div>
    );
};

const Mjml = () => {
    return (
        <ReactReduxContext.Consumer>
            {({ store }) => <MjmlContent store={store} />}
        </ReactReduxContext.Consumer>
    );
}

export default Mjml;
